/**
 * InvestMeIn — Web Entry Point
 *
 * All imports are dynamic to ensure the error handler is registered
 * before any module code runs.
 */

// 1. Global error handler — registered FIRST, before any imports
window.addEventListener('error', (event) => {
    console.error('[Global Error]', event.error);
    const errDiv = document.createElement('div');
    errDiv.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:#FEE2E2;display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:99999;padding:32px';
    errDiv.innerHTML = `<h2 style="color:#DC2626">JS Error</h2><pre style="color:#64748B;max-width:600px;white-space:pre-wrap;font-size:12px">${event.error?.stack || event.message}</pre>`;
    document.body.appendChild(errDiv);
});

window.addEventListener('unhandledrejection', (event) => {
    console.error('[Unhandled Promise]', event.reason);
});

// 2. Boot: all imports are dynamic inside this function
async function boot() {
    const loadingSplash = document.getElementById('loading');
    if (loadingSplash) loadingSplash.remove();

    try {
        const { AppRegistry } = await import('react-native');
        const { default: App } = await import('./src/App');

        AppRegistry.registerComponent('InvestMeIn', () => App);
        AppRegistry.runApplication('InvestMeIn', {
            initialProps: {},
            rootTag: document.getElementById('root'),
        });
    } catch (e) {
        console.error('[Boot Error]', e);
        const root = document.getElementById('root');
        if (root) {
            root.innerHTML = `<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;gap:16px;padding:32px">
                <div style="font-size:48px">\u26a0\ufe0f</div>
                <div style="font-size:24px;font-weight:800;color:#DC2626">Boot Error</div>
                <pre style="font-size:12px;color:#64748B;max-width:600px;white-space:pre-wrap;word-break:break-all">${e.stack || e.message}</pre>
            </div>`;
        }
    }
}

boot();

// Register Service Worker for PWA (production only)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/sw.js')
            .then((reg) => console.log('SW registered:', reg.scope))
            .catch((err) => console.warn('SW registration failed:', err));
    });
}
